import { z } from 'zod';
import { draftClaimLineItemContext } from '~/app/features/crew/claim-line-items/claimLineItemMiddleware';
import { crewOrderContext } from '~/app/features/order-middleware/orderMiddleware';
import { makeLoader } from '~/utils/routing';

const paramsSchema = z.object({
  store: z.string(),
  idFromPlatform: z.string(),
});

export const { loader, useLoaderData } = makeLoader(({ context, params }) => {
  const draftClaimLineItem = context.get(draftClaimLineItemContext);
  const { wasShippingProtected } = context.get(crewOrderContext);
  const { store, idFromPlatform } = paramsSchema.parse(params);

  if (!wasShippingProtected) {
    throw new Error('Order does not have shipping protection');
  }

  return {
    reasonId: draftClaimLineItem.reasonId,
    shippingProtectionUrl: `/${store}/reorder/${idFromPlatform}`,
  };
});
